<div mat-dialog-title>
    <h1>{{ 'messages.dialog.title' | translate }}</h1>
    <button id="{{idPrefix}}btn.x" mat-button class="close close-btn" tabindex="-1" [mat-dialog-close]="">
        <mat-icon class="dr-material-icon">clear</mat-icon>
    </button>
</div>

<div mat-dialog-content>

    <ag-grid-angular
        #agGridMessages
        class="ag-theme-material"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [gridOptions]="gridOptions">
    </ag-grid-angular>

</div>

<div mat-dialog-actions class="mt-2">

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.read_and_close" mat-raised-button class="full-width" color="accent" (click)="markAllAsReadAndClose()">{{ 'messages.dialog.button_read' | translate }}</button>
    </div>
    
    <div class="col-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.close" mat-stroked-button color="primary" class="full-width" (click)="close()">{{ 'common.btn.cancel' | translate }}</button>
    </div>

</div>
